import axios from 'axios';
export class LinksService {
    static getLinks() {
        return axios.get(`/api/links/`)
            .then(data => {
            return data.data;
        });
    }
}
